import { createCRUDHook } from './createCRUDHook';
import { CustomerAlertDto } from 'utils/models';
import { TBL_CUSTOMER_ALERT } from './apiEndPoints';

// Create the CRUD hook - that's it!
const { Context, useManager, useConsumer } = createCRUDHook<CustomerAlertDto>({
  entityName: 'CustomerAlert',
  endpoint: TBL_CUSTOMER_ALERT,
});

export const CustomerAlertContext = Context;
export const useCustomerAlertManager = useManager;
export const useCustomerAlert = useConsumer;
